import React, { useState } from 'react';
import aboutImg from '../../assets/About/About2.webp';
import './About.css';

const VALUES = [
  {
    icon: '◎',
    title: 'Supervisión Técnica',
    desc: 'Supervisamos cada etapa del proyecto para garantizar control, calidad y cumplimiento durante la ejecución de obra.',
  },
  {
    icon: '⬡',
    title: 'Ejecución de Obra',
    desc: 'Desarrollamos proyectos con planificación eficiente, precisión constructiva y enfoque en resultados duraderos.',
  },
  {
    icon: '◈',
    title: 'Infraestructura Civil',
    desc: 'Participamos en proyectos de infraestructura orientados al desarrollo funcional y sostenible de cada entorno.',
  },
  {
    icon: '❋',
    title: 'Proyectos Corporativos',
    desc: 'Ejecutamos obras para clientes corporativos bajo altos estándares de calidad, imagen y cumplimiento.',
  },
];

const About = () => {
  const [activeValueTitle, setActiveValueTitle] = useState(null);

  const toggleValue = (title) => {
    // En desktop real (mouse/trackpad) se activa con hover.
    // En touch/tablet/híbridos (pointer coarse) mantenemos tap/click como fallback.
    const hoverFine =
      typeof window !== 'undefined' &&
      window.matchMedia?.('(hover: hover) and (pointer: fine)')?.matches;

    if (hoverFine) return;
    setActiveValueTitle((prev) => (prev === title ? null : title));
  };

  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about__grid">
          {/* Visual */}
          <div className="about__visual">
            <div className="about__img-wrap">
              <img
                src={aboutImg}
                alt="Obras de construcción Consuprog"
                className="about__img-main"
                loading="lazy"
              />
              <div className="about__info-cards">
                <div className="about__info-card">
                  <svg className="about__info-icon" width="36" height="36" viewBox="0 0 36 36" fill="none">
                    <path d="M18 4L6 9V18C6 25.2 11.4 31.8 18 33.5C24.6 31.8 30 25.2 30 18V9L18 4Z" stroke="#22c55e" strokeWidth="1.6" strokeLinejoin="round"/>
                    <path d="M13 18L16.5 21.5L23 15" stroke="#22c55e" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <div>
                    <div className="about__info-title">Seguridad</div>
                    <div className="about__info-sub">Como prioridad</div>
                  </div>
                </div>
                <div className="about__info-card">
                  <svg className="about__info-icon" width="36" height="36" viewBox="0 0 36 36" fill="none">
                    <circle cx="18" cy="14" r="8" stroke="#22c55e" strokeWidth="1.6"/>
                    <path d="M12 21L9 32L18 28L27 32L24 21" stroke="#22c55e" strokeWidth="1.6" strokeLinejoin="round"/>
                    <path d="M15 14L17 16L21 12" stroke="#22c55e" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <div>
                    <div className="about__info-title">Calidad</div>
                    <div className="about__info-sub">En cada proyecto</div>
                  </div>
                </div>
              </div>
              <div className="about__visual-actions">
                <a href="#projects" className="btn-primary" onClick={(e) => { e.preventDefault(); document.querySelector('#projects')?.scrollIntoView({ behavior: 'smooth' }); }}>
                  Ver proyectos
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M3 8H13M13 8L8 3M13 8L8 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
                <a href="#contact" className="btn-outline" onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }}>
                  Cotizar obra
                </a>
              </div>
            </div>
          </div>

          {/* Text */}
          <div className="about__text">
            <h2 className="about__heading">
              Comprometidos con la <em>Calidad.</em>
            </h2>

            <p className="about__lead">
              Desarrollamos obras funcionales, eficientes y bien ejecutadas, cuidando
              cada detalle desde la planificación hasta la entrega final.
            </p>

            <div className="about__values">
              {VALUES.map((v) => {
                const isActive = activeValueTitle === v.title;
                return (
                  <button
                    key={v.title}
                    type="button"
                    className={`about__value ${isActive ? 'about__value--active' : ''}`}
                    onClick={() => toggleValue(v.title)}
                    aria-label={isActive ? `${v.title}. ${v.desc}` : v.title}
                    aria-pressed={isActive}
                  >
                    <span className="about__value-inner" aria-hidden="true">
                      <span className="about__value-face about__value-face--front">
                        <span className="about__value-icon">{v.icon}</span>
                        <span className="about__value-content">
                          <span className="about__value-title">{v.title}</span>
                        </span>
                        <span className="about__value-tap-hint" aria-hidden="true">&#8635;</span>
                      </span>

                      <span className="about__value-face about__value-face--back">
                        <span className="about__value-icon">{v.icon}</span>
                        <span className="about__value-content">
                          <span className="about__value-desc">{v.desc}</span>
                        </span>
                      </span>
                    </span>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
